<template>
  <div>
    <div class="top-row">
      <h2 class="team-name">{{ info.teamName }}</h2>
      <p class="team-captain">队长：{{ info.captainName }}</p>
      <p class="tips">
        <i class="el-icon-info"></i>
        <span>下面表格仅团队队长可填写和提交</span>
      </p>
      <el-button
        type="primary"
        size="medium"
        style="float: right"
        @click="handleSubmit"
        :disabled="!info.isCaptain"
        >提 交</el-button
      >
    </div>
    <table
      width="100%"
      border="1"
      cellspacing="0"
      cellpadding="20"
      align="center"
      class="table"
    >
      <tr class="head">
        <td colspan="2">自身（商家侧）</td>
        <td colspan="2">定位（交集）</td>
        <td colspan="2">用户（需求侧）</td>
      </tr>
      <tr>
        <td class="label" width="10%">产品属性</td>
        <td>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            resize="none"
            placeholder="请输入原料、生产过程、品牌、功能、特点、价格、背书、环境…"
            v-model="info.cpsx"
            :readonly="!info.isCaptain"
          >
          </el-input>
        </td>
        <td class="label" width="10%">功能价值</td>
        <td>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            resize="none"
            placeholder="提供哪些服务与价值"
            v-model="info.gnjz"
            :readonly="!info.isCaptain"
          >
          </el-input>
        </td>
        <td class="label" width="10%">用户需求</td>
        <td>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            resize="none"
            placeholder="请输入好用、可靠、面子、便宜、偷懒、猎奇、从众、求异…"
            v-model="info.yhxq"
            :readonly="!info.isCaptain"
          >
          </el-input>
        </td>
      </tr>
      <tr>
        <td class="label" width="10%">IP自身属性（外在）</td>
        <td>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            resize="none"
            placeholder="请输入性别、年龄、颜值、身材、学历、所在地、家庭状况、过往经历…"
            v-model="info.ipzssx"
            :readonly="!info.isCaptain"
          >
          </el-input>
        </td>
        <td class="label" width="10%">势能关系</td>
        <td>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            resize="none"
            placeholder="粉丝仰视、平视或俯视等"
            v-model="info.sngx"
            :readonly="!info.isCaptain"
          >
          </el-input>
        </td>
        <td class="label" width="10%">用户群体画像</td>
        <td>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            resize="none"
            placeholder="请输入性别、年龄段、城市、收入、学历、婚育…"
            v-model="info.yhqthx"
            :readonly="!info.isCaptain"
          >
          </el-input>
        </td>
      </tr>
      <tr>
        <td class="label" width="10%">IP人格属性（内在）</td>
        <td>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            resize="none"
            placeholder="请输入性格、喜好、特长、穿搭、口头禅、愿景…"
            v-model="info.iprgsx"
            :readonly="!info.isCaptain"
          >
          </el-input>
        </td>
        <td class="label" width="10%">情感性质</td>
        <td>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            resize="none"
            placeholder="粉丝当你是偶像、兄弟还是服务员"
            v-model="info.qgxz"
            :readonly="!info.isCaptain"
          >
          </el-input>
        </td>
        <td class="label" width="10%">审美喜好</td>
        <td>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            resize="none"
            placeholder="请输入正经、随和、江湖、走心、鸡汤、颜党…"
            v-model="info.smxh"
            :readonly="!info.isCaptain"
          >
          </el-input>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { myTeamInfo, submitInfo } from "@/api/projectPractice/accountLocation";
export default {
  data() {
    return {
      info: {},
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.$loading.show();
      myTeamInfo({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.info = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 提交信息（仅限队长）
    handleSubmit() {
      this.$confirm("确定要提交信息吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          this.info.classId = this.$route.query.id;
          submitInfo(this.info).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.getInfo();
              this.$message.success("提交成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.top-row {
  margin-bottom: 10px;
  text-align: left;
  overflow: hidden;
  .team-name,
  .team-captain {
    display: inline-block;
    &.team-captain {
      margin-left: 20px;
    }
  }
  .tips {
    display: inline-block;
    margin-left: 50px;
    color: #f56c6c;
    text-align: left;
    i {
      margin-right: 5px;
    }
  }
}
.table {
  border-color: #f2f6fc;
  .head {
    background: #f5f5f5;
    font-weight: bold;
  }
  .label {
    font-weight: bold;
  }
  ::v-deep .el-textarea__inner {
    padding: 0;
    font-family: inherit;
    border: none;
    text-align: center;
  }
}
</style>